<div class="wrapper">
  <div class="header-section flex justify-start items-start gap-[32px]">
    @if (!isContractor) {
      <div
        (click)="selectSubTab('settings')"
        [class.selected]="activeSubTab === 'settings'"
        class="header text-type-3 cursor-pointer text-[#60698B]">
        Punch lists
      </div>
    }
    @if (punchlists.length) {
      <div
        (click)="selectSubTab('items')"
        [class.selected]="activeSubTab === 'items'"
        class="header text-type-3 cursor-pointer text-[#60698B]">
        Items
      </div>
    }
  </div>

  <div class="content-section">
    @if (loading) {
      <div class="loading">Loading…</div>
    } @else {
      @switch (activeSubTab) {
        @case ('settings') {
          <app-punchlist-settings
            [projectId]="projectId"
            [punchlists]="punchlists"
            (changed)="onPunchlistsChanged()"
            (selectPunchlist)="onSelectPunchlist($event)" />
        }
        @case ('items') {
          @if (currentPunchlist) {
            <app-punchlist-items-list
              [projectId]="projectId"
              [punchlist]="currentPunchlist"
              [punchlists]="punchlists"
              (punchlistChange)="onSelectPunchlist($event)" />
          } @else {
            <div class="empty">No punch list set up yet. Switch to the Punch lists tab to create one.</div>
          }
        }
      }
    }
  </div>
</div>
